import TgBtn from './TgBtn';
import './tg-btn.scss'

export default TgBtn;